import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import Account from './account-model';
import AccountActions from './account-actions';

const initialState = Immutable({
  active:           Account.deserialize(App.globalContext.account),
  relativeAccounts: {
    byId: {},
  },
});

const reducer = createReducer((on) => {
  on([AccountActions.fetchCurrentAccountSuccess, AccountActions.saveCurrentAccountSuccess], (state, { account }) =>
    state.set('active', account)
  );

  on([AccountActions.updateCurrentAccountProperty], (state, { id, value }) => state.setIn(['active', id], value));

  on(AccountActions.fetchRelativeAccountsSuccess, (state, { accountList }) => {
    const byId = _.reduce(
      accountList,
      (acc, form) => {
        acc[form.id] = form;
        return acc;
      },
      {}
    );

    return state.setIn(['relativeAccounts', 'byId'], byId);
  });
}, initialState);

export default reducer;
